document.addEventListener('DOMContentLoaded', () => {
  const ageGate = document.querySelector('[data-age-gate]');
  if (ageGate && localStorage.getItem('pc-age-confirmed') !== 'true') {
    ageGate.hidden = false;
    document.body.classList.add('is-locked');
    ageGate.querySelector('[data-age-confirm]')?.focus();
  }
  ageGate?.querySelector('[data-age-confirm]')?.addEventListener('click', () => {
    localStorage.setItem('pc-age-confirmed', 'true');
    ageGate.hidden = true;
    document.body.classList.remove('is-locked');
  });

  const menuButton = document.querySelector('[data-mobile-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  menuButton?.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(open));
  });

  document.querySelectorAll('[data-tabs]').forEach((tabs) => {
    tabs.querySelectorAll('[role="tab"]').forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.querySelectorAll('[role="tab"]').forEach((item) => item.setAttribute('aria-selected', 'false'));
        tabs.querySelectorAll('[role="tabpanel"]').forEach((panel) => panel.classList.remove('is-active'));
        tab.setAttribute('aria-selected', 'true');
        tabs.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`)?.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const button = root.querySelector('[data-add-to-cart]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyButton = document.querySelector('[data-sticky-add]');
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      price.textContent = option.dataset.price;
      if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.soldLabel;
    });
    stickyButton?.addEventListener('click', () => button.click());
  });
  const backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    const toggleBackToTop = () => {
      const shouldShow = window.scrollY > 420;
      backToTop.hidden = false;
      backToTop.classList.toggle('is-visible', shouldShow);
      backToTop.setAttribute('aria-hidden', String(!shouldShow));
    };
    toggleBackToTop();
    window.addEventListener('scroll', toggleBackToTop, { passive: true });
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }
});

